import request from "@/utils/request";

// 用户管理-列表
export function userListApi(data) {
    return request({
      url: "/admin/admin_users",
      method: "get",
      params: data
    });
  }

// 用户管理-新增 (提交)
export function addUserApi(data) {
    return request({
      url: "/admin/admin_users",
      method: "post",
      data
    });
  }


// 用户管理-编辑 (获取)
export function getEditUserApi(data) {
    return request({
      url: "/admin/admin_users/" + data.id,
      method: "get",
      params: data
    });
  }

// 用户管理-编辑 (获取当前用户已选权限)
export function getUserPermissionsApi(data) {
    return request({
      url: "/admin/get_user_permissions",
      method: "get",
      params: data
    });
  }

// 用户管理-编辑 (提交)
export function putEditUserApi(data) {
    return request({
      url: "/admin/admin_users/" + data.id,
      method: "put",
      data
    });
  }

// 用户管理-获取角色列表
export function getRoleListApi(data) {
    return request({
      url: "/admin/get_role_list",
      method: "get",
      params: data
    });
  }

// 获取权限树
export function getPermissionTreeApi(data) {
    return request({
      url: "/admin/get_permission_tree",
      method: "get",
      params: data
    });
  }

// 用户管理-删除
export function deleteUserApi(data) {
    return request({
      url: "/admin/admin_users/" + data.id,
      method: "delete",
      data
    });
  }



// 重置密码
export function resetPasswordApi(data) {
    return request({
      url: "/admin/reset_password/" + data.id,
      method: "put",
      data
    });
  }

// 禁用/还原用户状态
export function setUserStatusApi(data) {
    return request({
      url: "/admin/set_user_status/" + data.id,
      method: "put",
      data
    });
  }

// 登录后获取用户导航栏
export function getUserNavigationApi() {
    return request({
      url: "/admin/get_user_navigation",
      method: "get",
    });
  }

// 获取城市组别
export function getAdminCityApi() {
    return request({
      url: "/admin/get_admin_city_group",
      method: "get"
    });
  }

// 获取父级权限列表
export function getParentPermissionApi() {
  return request({
    url: "/admin/get_parent_permission",
    method: "get"
  });
}